var map = {
	"./patch_notes/temp_delete_me.png": [
		74352,
		804
	],
	"./patch_notes/v283/shifting_content_after.png": [
		71130,
		804
	],
	"./patch_notes/v283/shifting_content_before.png": [
		37207,
		804
	],
	"./patch_notes/v283/shuffle_card_after.png": [
		13048,
		804
	],
	"./patch_notes/v283/shuffle_card_before.png": [
		63593,
		804
	],
	"./patch_notes/v283/stop-achievements-blocking-after.png": [
		63977,
		804
	],
	"./patch_notes/v283/stop-achievements-blocking-before.png": [
		32534,
		804
	],
	"./patch_notes/v284/android_status_bar_after.png": [
		52745,
		804
	],
	"./patch_notes/v284/android_status_bar_before.png": [
		83446,
		804
	],
	"./patch_notes/v284/city_improvement_mobile_after.png": [
		22578,
		804
	],
	"./patch_notes/v284/city_improvement_mobile_before.png": [
		10479,
		804
	],
	"./patch_notes/v284/counter_offer_8p_after.png": [
		48071,
		804
	],
	"./patch_notes/v284/counter_offer_8p_before.png": [
		40136,
		804
	],
	"./patch_notes/v284/trade_counter_offer_after.png": [
		35563,
		804
	],
	"./patch_notes/v284/trade_counter_offer_before.png": [
		66460,
		804
	],
	"./patch_notes/v286/bot_kick_confirmation_before.png": [
		74862,
		804
	],
	"./patch_notes/v286/room_guests_after.png": [
		31338,
		804
	],
	"./patch_notes/v286/room_guests_before.png": [
		63751,
		804
	],
	"./patch_notes/v287/ios_dice_resolution_after.png": [
		41816,
		804
	],
	"./patch_notes/v287/ios_dice_resolution_before.png": [
		41001,
		804
	],
	"./patch_notes/v287/mobile_endgame_after.png": [
		62814,
		804
	],
	"./patch_notes/v287/mobile_endgame_before.png": [
		5675,
		804
	],
	"./patch_notes/v288/new_badge_after.png": [
		75577,
		804
	],
	"./patch_notes/v288/new_badge_before.png": [
		8678,
		804
	],
	"./patch_notes/v289/fix_pixelated_fullscreen_popup_after.png": [
		68905,
		804
	],
	"./patch_notes/v289/fix_pixelated_fullscreen_popup_before.png": [
		96950,
		804
	],
	"./patch_notes/v289/group_owned_maps_after.png": [
		46873,
		804
	],
	"./patch_notes/v289/group_owned_maps_before.png": [
		85606,
		804
	],
	"./patch_notes/v289/message_appears_without_username_avatar_after.png": [
		90416,
		804
	],
	"./patch_notes/v289/message_appears_without_username_avatar_before.png": [
		14433,
		804
	],
	"./patch_notes/v289/rename_lobby_to_room_after.png": [
		27935,
		804
	],
	"./patch_notes/v289/rename_lobby_to_room_before.png": [
		47168,
		804
	],
	"./patch_notes/v289/update_payment_successful_popup_after.png": [
		72236,
		804
	],
	"./patch_notes/v289/update_payment_successful_popup_before.png": [
		71181,
		804
	],
	"./patch_notes/v292/portrait_new_top_bar_after.png": [
		91766,
		804
	],
	"./patch_notes/v292/portrait_new_top_bar_before.png": [
		64483,
		804
	],
	"./patch_notes/v293/new_leaderboard_icon_after.png": [
		20175,
		804
	],
	"./patch_notes/v293/new_leaderboard_icon_before.png": [
		15568,
		804
	],
	"./patch_notes/v293/page_scrolling_after.png": [
		65364,
		804
	],
	"./patch_notes/v293/page_scrolling_before.png": [
		92437,
		804
	],
	"./patch_notes/v294/new_homepage_cards_after.png": [
		18393,
		804
	],
	"./patch_notes/v294/new_homepage_cards_before.png": [
		61350,
		804
	],
	"./patch_notes/v295/checkout_button_after.png": [
		79754,
		804
	],
	"./patch_notes/v295/checkout_button_before.png": [
		25735,
		804
	],
	"./patch_notes/v295/new_game_mode_icons_after.gif": [
		2638,
		804
	],
	"./patch_notes/v295/new_game_mode_icons_before.gif": [
		68525,
		804
	],
	"./patch_notes/v295/portrait-player-info-before.png": [
		90720,
		804
	],
	"./patch_notes/v295/portrait-player-info-new.gif": [
		32560,
		804
	],
	"./patch_notes/v295/portrait-player-info-new.png": [
		25827,
		804
	],
	"./patch_notes/v295/store_popup_tablet_after.png": [
		20296,
		804
	],
	"./patch_notes/v295/store_popup_tablet_before.png": [
		42521,
		804
	],
	"./patch_notes/v296/1v1-new.png": [
		54550,
		804
	],
	"./patch_notes/v296/1v1-old.png": [
		85075,
		804
	],
	"./patch_notes/v296/new-menu-icons-after.png": [
		6479,
		804
	],
	"./patch_notes/v296/new-menu-icons-before.png": [
		71728,
		804
	],
	"./patch_notes/v296/tablet-layout-new.png": [
		37331,
		804
	],
	"./patch_notes/v296/tablet-layout-old.png": [
		81242,
		804
	],
	"./patch_notes/v296/toast-vertical-align-after.png": [
		12872,
		804
	],
	"./patch_notes/v296/toast-vertical-align-before.png": [
		88409,
		804
	],
	"./patch_notes/v297/chat-dice-overlap-after.png": [
		9641,
		804
	],
	"./patch_notes/v297/chat-dice-overlap-before.png": [
		28662,
		804
	],
	"./patch_notes/v297/fix-hover-after.png": [
		48549,
		804
	],
	"./patch_notes/v297/fix-hover-before.png": [
		79026,
		804
	],
	"./patch_notes/v297/fix-pencil-icon-after.png": [
		20848,
		804
	],
	"./patch_notes/v297/fix-pencil-icon-before.png": [
		17153,
		804
	],
	"./patch_notes/v297/more-page-after.png": [
		44908,
		804
	],
	"./patch_notes/v297/more-page-before.png": [
		13901,
		804
	],
	"./patch_notes/v297/move-profile-page-after.png": [
		55396,
		804
	],
	"./patch_notes/v297/move-profile-page-before.png": [
		16549,
		804
	],
	"./patch_notes/v298/2-3p-mobile-ui-after.png": [
		52274,
		804
	],
	"./patch_notes/v298/2-3p-mobile-ui-before.png": [
		6639,
		804
	],
	"./patch_notes/v298/endgame-flag-after.png": [
		26546,
		804
	],
	"./patch_notes/v298/endgame-flag-before.png": [
		55919,
		804
	],
	"./patch_notes/v298/game-mode-reorder-after.png": [
		95818,
		804
	],
	"./patch_notes/v298/game-mode-reorder-before.png": [
		95335,
		804
	],
	"./patch_notes/v298/login-redesign-after.png": [
		64191,
		804
	],
	"./patch_notes/v298/login-redesign-before.png": [
		67744,
		804
	],
	"./patch_notes/v298/mobile-login-after.png": [
		86620,
		804
	],
	"./patch_notes/v298/mobile-login-before.png": [
		37885,
		804
	],
	"./patch_notes/v298/web-login-popup-after.png": [
		31125,
		804
	],
	"./patch_notes/v298/web-login-popup-before.png": [
		67042,
		804
	],
	"./patch_notes/v299/card-container-transparency-after.png": [
		56140,
		804
	],
	"./patch_notes/v299/card-container-transparency-before.png": [
		90125,
		804
	],
	"./patch_notes/v299/floating-text-pill-style-after.png": [
		63992,
		804
	],
	"./patch_notes/v299/floating-text-pill-style-before.png": [
		47612,
		804
	],
	"./patch_notes/v299/ios-context-menu-before.png": [
		58515,
		804
	],
	"./patch_notes/v299/profile-page-after.png": [
		81856,
		804
	],
	"./patch_notes/v299/profile-page-before.png": [
		53137,
		804
	],
	"./patch_notes/v299/tab-slide-after.gif": [
		96361,
		804
	],
	"./patch_notes/v299/tab-slide-before.gif": [
		75796,
		804
	],
	"./patch_notes/v299/tile_highlights_after.png": [
		23941,
		804
	],
	"./patch_notes/v299/tile_highlights_before.png": [
		44242,
		804
	],
	"./patch_notes/v299/username-after.png": [
		8153,
		804
	],
	"./patch_notes/v299/username-before.png": [
		60614,
		804
	],
	"./patch_notes/v299/web-more-page-after.png": [
		39867,
		804
	],
	"./patch_notes/v299/web-more-page-before.png": [
		39948,
		804
	],
	"./patch_notes/v300/hard-bot-after.png": [
		34575,
		804
	],
	"./patch_notes/v300/hard-bot-before.png": [
		77264,
		804
	],
	"./patch_notes/v300/new-web-sidebar-after.png": [
		44352,
		804
	],
	"./patch_notes/v300/new-web-sidebar-before.png": [
		40593,
		804
	],
	"./patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-after.png": [
		77247,
		804
	],
	"./patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-before.png": [
		24160,
		804
	],
	"./patch_notes_images/dang-increase-end-game-size-after.png": [
		20065,
		804
	],
	"./patch_notes_images/dang-increase-end-game-size-before.png": [
		77422,
		804
	],
	"./patch_notes_images/dang-update-payment-successful-popup-after.png": [
		37414,
		804
	],
	"./patch_notes_images/dang-update-payment-successful-popup-before.png": [
		72179,
		804
	],
	"./patch_notes_images/message-appears-without-username-avatar-after.png": [
		70653,
		804
	],
	"./patch_notes_images/message-appears-without-username-avatar-before.png": [
		75466,
		804
	],
	"./patch_notes_images/rename-lobby-to-room-after.png": [
		6734,
		804
	],
	"./patch_notes_images/rename-lobby-to-room-before.png": [
		48027,
		804
	],
	"./patch_notes_images/stan-fix-safari-low-resolution-dice-after.jpg": [
		64428,
		804
	],
	"./patch_notes_images/stan-fix-safari-low-resolution-dice-before.jpg": [
		25873,
		804
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 88341;
module.exports = webpackAsyncContext;